import { ContentCopy } from '@mui/icons-material';
import { Box, Divider, FormControl, IconButton, InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material';
import React, { forwardRef } from 'react';

// eslint-disable-next-line no-unused-vars
const TwoFactoryForm = forwardRef((props, ref) => {
  const { secretKey, qrCode } = props;

  const handleClickClipboard = () => {
    navigator.clipboard.writeText(secretKey);
  };

  return (
    <form>
      <Stack
        direction='row'
        flexDirection='column'
        alignItems='center'
        sx={(theme) => ({
          padding: theme.spacing(2, 0),
          img: {
            width: '180px',
          },
        })}>
        <img src={`data:image/svg+xml;utf8,${encodeURIComponent(qrCode)}`} />
      </Stack>
      <Box
        component='div'
        sx={(theme) => ({
          margin: theme.spacing(2, 0),
          '.MuiTypography-body1': {
            marginTop: theme.spacing(2),
            wordBreak: 'break-all',
            textAlign: 'center',
          },
          '.MuiTypography-body2': {
            color: theme.palette.text.secondary,
          },
          '.MuiOutlinedInput-input': {
            padding: '0!important',
          },
        })}>
        <Divider textAlign='center'>
          <Typography variant='body2'>Или введите ключ вручную</Typography>
        </Divider>
        <FormControl margin='normal' variant='outlined' fullWidth>
          <OutlinedInput
            id='outlined-adornment-secret-key'
            type='text'
            variant='outlined'
            defaultValue={secretKey}
            fullWidth
            readOnly
            multiline
            endAdornment={
              <InputAdornment position='end'>
                <IconButton edge='end' onClick={handleClickClipboard}>
                  <ContentCopy fontSize='small' />
                </IconButton>
              </InputAdornment>
            }></OutlinedInput>
        </FormControl>
      </Box>
    </form>
  );
});

export default TwoFactoryForm;
